export default "__VITE_ASSET__CLpbMCU$__"